import { render, staticRenderFns } from "./recommend-result-cqc.vue?vue&type=template&id=7af370af&scoped=true&"
import script from "./recommend-result-cqc.vue?vue&type=script&lang=js&"
export * from "./recommend-result-cqc.vue?vue&type=script&lang=js&"
import style0 from "./recommend-result-cqc.vue?vue&type=style&index=0&id=7af370af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af370af",
  null
  
)

export default component.exports